import { Navigate, useParams } from "react-router-dom";

/**
 * Redirects the retired /infusions/<slug> embed path to /embed/<slug>.
 *
 * Luna and this app deploy independently, so during a rollout a browser
 * holding a cached Luna bundle still iframes /infusions/<slug>. Without this
 * it would render an empty NotFoundPage inside the frame. Drop this route —
 * and the file — one release after Luna stops emitting the old path.
 */
export function LegacyEmbedRedirect() {
  const { slug } = useParams<{ slug: string }>();

  return <Navigate to={`/embed/${slug ?? ""}`} replace />;
}
